module.exports = __webpack_public_path__ + "static/hit-refresh-7da90d22b380ebd6092219603381a486.jpg";